/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { CircularProgress } from '@material-ui/core';

import { useInjectEpics } from 'utils/injectEpics';
import { useInjectReducer } from 'utils/injectReducer';
import { selectUser } from 'entities/user/selectors';

import reducer from './reducers';
import epics from './epics';
import * as Actions from './actions';
import { selectLoading } from './selectors';

const key = 'organizationAuthorizeStripePage';

const OrganizationAuthorizeStripePage = ({ actions, loading, location, user }) => {
  useInjectReducer({ key, reducer });
  useInjectEpics({ key, epics });
  useEffect(() => {
    if (user) {
      actions.initAction(location.search);
    }
  }, [user]);

  return (
    <>
      <Helmet title="Donations" />
      <h1>Donations</h1>
      {loading && <CircularProgress />}
    </>
  );
};

OrganizationAuthorizeStripePage.propTypes = {
  actions: PropTypes.object,
  location: PropTypes.object,
  user: PropTypes.object,
  loading: PropTypes.bool,
};

const withConnect = connect(
  createStructuredSelector({
    loading: selectLoading,
    user: selectUser,
  }),
  (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
  })
);

export default withConnect(OrganizationAuthorizeStripePage);
